import { render } from "./LbrxSimpleCalendarView.vue?vue&type=template&id=55c95d15"
import script from "./LbrxSimpleCalendarView.vue?vue&type=script&lang=js"
export * from "./LbrxSimpleCalendarView.vue?vue&type=script&lang=js"

import "./LbrxSimpleCalendarView.vue?vue&type=style&index=0&id=55c95d15&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__